import * as React from "react";

import { cn } from "@ui/lib/utils";

// YANGO DELI loading placeholder (BF-578, re-skinned BF-733). Muted (--muted)
// surface fill, rounded corners (--radius, rounded-md), a plain opacity pulse —
// no chromatic shimmer.
function Skeleton({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="skeleton"
      className={cn("bg-muted animate-pulse rounded-md", className)}
      {...props}
    />
  );
}

export { Skeleton };
